import React from 'react'
import { useSelector } from 'react-redux'
import { ACCOUNT_PAGE_VARIANTS } from 'constants/uiConfig'

const LazyAccountV1 = React.lazy(() => import('./AccountPageV1'))
const LazyAccountV2 = React.lazy(() => import('./AccountPageV2'))

const Account = (props) => {
  const general = useSelector((s) => s.uiConfig?.general)
  const cfg = general?.accountPageVariant ?? ACCOUNT_PAGE_VARIANTS.V1
  const variant = typeof cfg === 'object' && cfg?.variant ? cfg.variant : cfg

  if (variant === ACCOUNT_PAGE_VARIANTS.V2) {
    return <LazyAccountV2 {...props} />
  }
  return <LazyAccountV1 {...props} />
}

export default Account
